export default {
  name: null,
  users: [],
  events: [],
  tenants: [],
  groups:[]
};
